import styled from 'styled-components';
import { Link as LinkComponent } from 'react-router-dom';

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
